import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UserService} from './user.service';

@Injectable()
export class BiometryGuard implements CanActivate {
  constructor(private userService: UserService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.userService.getLocal();
    if (!user || !user.biometryRequired) {
      return true;
    }
    if (state.url.indexOf('/dashboard/biometry') === 0) {
      return true;
    }
    this.router.navigate(['/dashboard/biometry'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/biometry-guard.service.ts